import React from 'react';
import { ShowProps, useShowController } from 'react-admin';
import ImmunotherapyTreatment from './ImmunotherapyTreatment/index';
import NutritionAdvice from './NutritionAdvice/index';

const TreatmentsShow = (props: ShowProps) => {
  const { record } = useShowController(props);

  if (record?.type === 'nutritionAdvice') {
    return <NutritionAdvice {...props} />;
  }

  return <ImmunotherapyTreatment {...props} />;
};

export default TreatmentsShow;
